<template>
    <el-dialog :visible.sync="addDialogVisible" :before-close="cancelForm" width="40%" center>
        <template slot="title">
            <div class="add_title">
                {{ title }}
            </div>
        </template>
        <div class="authority">
            <!-- <div class="title">新增规则</div> -->
            <div class="info">
                <div class="user">
                    <div class="basic_box">
                        <div class="basic_title">
                            <div>基本信息</div>
                            <img src="../../../assets/文本.png" alt="">
                        </div>
                        <el-form ref="form" :model="form" label-width="110px">
                            <el-form-item label="点位类型">
                                <el-select v-model="form.p_type_id" placeholder="请选择点位类型">
                                    <el-option v-for="item in ptype" :key="item.id" :label="item.name" :value="item.id">
                                    </el-option>
                                </el-select>

                            </el-form-item>
                            <el-form-item label="点位名称">
                                <el-col :span="8">
                                    <el-input v-model="form.name" placeholder="请输入点位名称"></el-input>
                                </el-col>
                            </el-form-item>
                            <el-form-item label="点位编码">
                                <el-col :span="8">
                                    <el-input v-model="form.p_code" placeholder="请输入点位编码"></el-input>
                                </el-col>
                            </el-form-item>
                            <el-form-item label="设备绑定">
                                <el-col :span="8">
                                    <el-cascader v-model="form.eq_type_id" :options="eqtree"
                                        :props="{ children: 's_types', label: 'name', value: 'id', emitPath: false }"
                                        @change="handleChange" :disabled="attrsable"></el-cascader>
                                    <!-- <el-input v-model="form.p_code" placeholder="请输入规则名称"></el-input> -->
                                </el-col>
                            </el-form-item>
                            <el-form-item label="点位设定">
                                <div style="position: relative;" class="pointset">
                                    <div style="display: flex;">
                                        <div class="settype_left">
                                            <el-radio :label="0" v-model="settype.type">
                                                值设定
                                                <el-input-number v-model="settype.value"
                                                    controls-position="right"></el-input-number>
                                            </el-radio>
                                        </div>
                                        <div class="settype_right">
                                            <el-radio :label="1" v-model="settype.type">
                                                值设定
                                            </el-radio>
                                            <div class="up_down">
                                                <div class="up">
                                                    上限
                                                    <el-input-number v-model="settype.up"
                                                        controls-position="right"></el-input-number>
                                                </div>
                                                <div class="down">
                                                    下限
                                                    <el-input-number v-model="settype.down"
                                                        controls-position="right"></el-input-number>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </el-form-item>
                            <el-form-item label="设备极限设定">
                                <el-col :span="8">
                                    <div class="up">
                                        上限
                                        <el-input-number v-model="form.ultimate[1]"
                                            controls-position="right"></el-input-number>
                                    </div>
                                    <div class="down">
                                        下限
                                        <el-input-number v-model="form.ultimate[0]"
                                            controls-position="right"></el-input-number>
                                    </div>
                                </el-col>
                            </el-form-item>
                            <el-form-item label="单步设定幅度">
                                <!-- <el-col :span="8">
                                    <el-input v-model="form.step_amplitude" placeholder="请输入单步设定幅度"></el-input>
                                </el-col> -->
                                <el-col :span="8">
                                    <div class="up">
                                        上限
                                        <el-input-number v-model="form.step_amplitude[1]"
                                            controls-position="right"></el-input-number>
                                    </div>
                                    <div class="down">
                                        下限
                                        <el-input-number v-model="form.step_amplitude[0]"
                                            controls-position="right"></el-input-number>
                                    </div>
                                </el-col>
                            </el-form-item>
                            <el-form-item label="执行间隔(min)">
                                <el-col :span="8">
                                    <el-input v-model="form.exe_interval" placeholder="请输入执行间隔"></el-input>
                                </el-col>
                            </el-form-item>
                            <el-form-item label="单位">
                                <el-col :span="8">
                                    <el-select v-model="form.unit_id" placeholder="请选择单位">
                                        <el-option v-for="item in unitlist" :key="item.id" :label="item.name"
                                            :value="item.id">
                                        </el-option>
                                    </el-select>
                                    <!-- <el-input v-model="form.unit_id" placeholder="请输入规则名称"></el-input> -->
                                </el-col>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div class="notice_box">
                        <div class="notice_title">
                            <div>状态信息</div>
                            <!-- <img src="../../../assets/加@2x.png" alt="" style="cursor: pointer;" @click="addrulelist()"> -->
                        </div>
                        <!-- <div class="rule_form">
                            <div class="traits_box">
                                <div class="form_item">
                                    <div class="my_item" v-for="(item, index) in rulelist">
                                        <div class="input_icon">
                                            <img src="../../../assets/减.png" alt="" @click="splicerulelist(index)">
                                            <img src="../../../assets/文本输入.png" alt="">
                                        </div>
                                        <div class="input_item">
                                            <span>
                                                选择指标
                                            </span>
                                            <el-col :span="8">
                                                <el-input v-model="form.name" placeholder="请输入规则名称"></el-input>
                                            </el-col>
                                        </div>
                                        <div class="input_item">
                                            <span>
                                                选择点位
                                            </span>
                                            <el-col :span="8">
                                                <el-input v-model="form.name" placeholder="请输入规则名称"></el-input>
                                            </el-col>
                                        </div>
                                        <div class="input_item">
                                            <span>
                                                指标信息
                                            </span>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> -->
                    </div>
                    <div class="demo-drawer__footer">
                        <el-button type="primary" @click="commitForm">确认提交</el-button>
                        <el-button class="cancelbutton" @click="cancelForm">取 消</el-button>
                    </div>
                </div>
            </div>
            <!-- </el-card> -->
        </div>
    </el-dialog>
</template>
<script>
import config from '@/utils/config';
export default {
    props: {
        addDialogVisible: Boolean,
        title: String,
        infoid: Number
    },
    components: {},
    data() {
        return {
            ptype: null,
            unitlist: null,
            rules: {
            },
            form: {
                state: 1,
                p_type_id: null,
                name: '',
                p_code: null,
                step_amplitude: ['', ''],
                exe_interval: '',
                unit_id: '',
                ultimate: ['', ''],
                eq_type_id: ''
            },
            settype: {
                type: null,
                value: '',
                down: '',
                up: ''
            },
            noti_content: '',
            ruleform: {
                logic: ''
            },
            oneform: {
                "tag": 'ces',
                "tagset": 'ces',
                "limitsymbol": '',
                "limitdire": '',
                "limittype": '',
                "limit": '',
                "duration": ''
            },
            current_username: "",
            state: "",
            switchtext: "",
            ruleenable: true,
            gradelist: [],
            moduleslist: [],
            operatelist: [],
            tagslist: [],
            command: "点位数值",
            listIndex: 0,
            rulelist: [
                {
                    tag: '',
                    limit: '',
                    operate: ''
                }
            ],
            traitslist: [
                {
                    tag: '',
                    limit: '',
                    operate: ''
                }
            ],
            configpub: {
                "tag": "",
                "work_time": '',
                "ab2norm_time": '',
                "direction": '',
                "isForbidden": true,
                rule: []
            },
            directionlist: [
                {
                    name: '出现异常时加药更安全',
                    id: 1
                }, {
                    name: '出现异常时减药更安全',
                    id: -1
                }, {
                    name: '出现异常对安全性不影响',
                    id: 0
                }
            ],
            checkList: [],
            algpublist: null,
            module_info: null,
            level_info: null,
            type_info: null,
            statusvalue: true,
            configradio: null,
            eqtree: null
        };
    },
    mounted() { },
    created() {
        // this.getlist();
        if (this.title == '编辑点位') {
            this.getlist()
        }
        // this.getdependlist()
        this.getptype()
        this.getpunitt()
        this.getdependlist()
        // this.form.ruletype = "点位数值";
    },
    methods: {
        //获取设备分类
        async getdependlist() {
            const { data: res } = await this.$http.get(config.httpPrefix + "/eq_type/all/tree");
            this.eqtree = res.data
        },
        //获取依赖信息
        async getptype() {
            const { data: res } = await this.$http.get(config.httpPrefix + "/p_type/all/np");
            console.log(res.data);
            this.ptype = res.data

            // this.module_info = res.data.module_info
            // this.level_info = res.data.level_info
            // this.type_info = res.data.type_info
        },
        async getpunitt() {
            const { data: res } = await this.$http.get(config.httpPrefix + "/p_unit/all/np");
            console.log(res.data);
            this.unitlist = res.data
            // this.module_info = res.data.module_info
            // this.level_info = res.data.level_info
            // this.type_info = res.data.type_info
        },
        async getlist() {
            console.log(this.infoid);
            const { data: res } = await this.$http.get(config.httpPrefix + "/point/" + this.infoid);

            this.form = res.data
            if (Array.isArray(res.data.set_value)) {
                this.settype.type = 1
                this.settype.down = res.data.set_value[0]
                this.settype.up = res.data.set_value[1]
            } else {
                this.settype.type = 0
                this.settype.value = res.data.set_value
            }
            console.log(res);
            console.log(this.settype);

            // this.gradelist = res.data.grade;
            // this.moduleslist = res.data.modules;
            // this.operatelist = res.data.operate;
            // this.tagslist = res.data.tags;
            //   this.modulesOption = res.data.modules;
            //   this.alertAllData = res.data.warnings;
        },
        goback() {
            console.log(1232131);
            this.$router.push({
                path: "/warningRule",
            });
        },
        //表头居中
        headClass() {
            return "text-align:center";
        },
        //表格居中
        rowClass() {
            return "text-align:center";
        },
        refreshlist() { },
        onSubmit() {
            console.log("submit!");
        },
        cancelForm() {
            // this.$refs["formName"].resetFields();
            this.$emit("closedrawer");
        },
        // 获取模块通用属性
        async changemodule(value) {
            console.log(value);
            const { data: res } = await this.$http.get(config.httpPrefix + "/alarm/algpub/filter?module=" + value);
            console.log(res);
            if (res.code == 200) {
                this.algpublist = res.data
            } else {

            }
        },
        async commitForm() {
            let commitform = null
            commitform = this.form
            console.log(commitform);
            if (this.settype.type == 0) {
                commitform.set_value = this.settype.value
            } else {
                commitform.set_value = [this.settype.down, this.settype.up]
            }
            if (this.title == '编辑点位') {
                const { data: res } = await this.$http.put(
                    config.httpPrefix + "/point/" + this.infoid,
                    commitform
                );
                console.log(res);
                if (res.code == 200) {
                    this.cancelForm()
                    this.$emit("updateData", res.data);
                    return this.$message.success("修改点位信息成功");
                } else {
                    this.$message.error(res.msg);
                }
            } else {

                const { data: res } = await this.$http.post(
                    config.httpPrefix + "/point",
                    commitform
                );
                console.log(res);
                if (res.code == 200) {
                    this.cancelForm()
                    return this.$message.success("添加点位成功");
                } else {
                    this.$message.error(res.msg);
                }
            }
        },
        //增加告警规则
        addruleform() {
            if (this.rulelist.length < 3) {

                this.rulelist.push({
                    tag: '',
                    logic: '',
                    operate: ''
                })
            } else {
                return this.$message.error("最多同时添加三个告警规则");
            }
        },
        //删除告警规则
        deleteruleform(index) {
            this.rulelist.splice(index, 1)
        },
        handleCommand(a) {
            this.command = a;
        },
        changeruletype(i) {
            this.form.ruletype = i
        },
        changelimitsymbol(i) {
            console.log(i);
        },
        changelogic(i) {
            console.log(i);
        },
        async changelistbar(id) {
            this.listIndex = id
            this.form.trigger_type = id
            console.log(id);
        },
        addrulelist() {
            this.rulelist.push({
                tag: '',
                limit: '',
                operate: ''
            })
            console.log(this.rulelist);
        },
        splicerulelist(index) {
            this.rulelist.splice(index, 1)
        }
    },
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
    border-radius: 20px !important;
}

.authority {
    height: 100%;
    // height: 940px !important;
    // background-color: #fff;
    border-radius: 20px;
    margin-right: 15px;
    margin-left: 15px;

    .content {
        height: 900px !important;
        padding: 25px;
        border-radius: 20px;
        border: 0;
    }

    .info {
        height: 100%;
        width: 100%;

        // display: flex;
        // flex-direction: column;
        // justify-content: center;
        // align-items: center;
        .user {

            // width: 800px;
            // height: 500px;
            .message {
                color: rgba(95, 95, 95, 0.664);
            }

            .demo-drawer__footer {
                text-align: center;
            }

            .change-label-calss {
                .el-form-item__label {
                    width: 0 !important;
                }
            }

            // background-color: red;
        }
    }

    .basic_box {
        border-bottom: 1px solid rgba(219, 219, 219, 1);

        .basic_title {
            display: flex;
            align-items: center;
            // justify-content: center;
            height: 21px;
            opacity: 1;
            font-size: 16px;
            font-weight: 500;
            letter-spacing: 0px;
            line-height: 20.27px;
            color: rgba(36, 102, 168, 1);
            margin-bottom: 20px;

            img {
                height: 16px;
                margin-left: 6px;
            }
        }

        .pointset {
            // max-width: 800px;
            height: 80px;
        }

        .settype_left {
            margin-right: 20px;
        }

        .settype_right {
            position: relative;
        }

        .up_down {
            z-index: 9;
            position: absolute;
            top: 0;
            left: 100%;
            min-width: 250px;
            // top: -13px;
            // right: -230px; // left: 45%;
            // display: ;
        }

        .down {
            margin-top: 20px;
            // margin-left: 357px;
        }
    }

    .rule_box {
        margin-top: 30px;
        border-bottom: 1px solid rgba(219, 219, 219, 1);

        .rule_title {
            display: flex;
            align-items: center;
            // justify-content: center;
            height: 21px;
            opacity: 1;
            font-size: 16px;
            font-weight: 500;
            letter-spacing: 0px;
            line-height: 20.27px;
            color: rgba(36, 102, 168, 1);
            margin-bottom: 20px;

            img {
                height: 16px;
                margin-left: 6px;
            }
        }
    }

    .rule_form {
        border-radius: 10px;
        padding-bottom: 30px;
        margin-bottom: 30px;
        padding-top: 1px;
        background: rgba(36, 102, 168, 0.1);

        .form_item {
            margin-top: 20px;
            margin-left: 20px;
            margin-right: 20px;

            .item_text {
                display: inline-block;
                margin-right: 10px;
            }

            .addform_title {
                display: flex;
                align-items: center;
                margin-bottom: 16px;

                img {
                    margin-left: 12px;
                    width: 20px;
                    cursor: pointer;
                }
            }

            .my_item {
                border-radius: 8px;
                background: rgba(255, 255, 255, 1);
                margin-bottom: 20px;
                padding: 20px;

                img {
                    float: right;
                    width: 16px;
                    cursor: pointer;
                    margin-right: 10px;
                }

                .input_item {
                    display: flex;
                    align-items: center;
                    margin-bottom: 20px;

                    span {
                        display: inline-block;
                        margin-right: 10px;
                    }
                }

                .input_item:last-child {
                    margin-bottom: 0px;
                }

                .sf_input_item {
                    display: flex;
                    align-items: center;
                    margin-bottom: 20px;

                    i {
                        line-height: 40px;

                    }


                }

                .sf_input_item:last-child {
                    margin-bottom: 0px;
                }
            }


            .sf_item {
                border-bottom: 2px solid rgba(219, 219, 219, 1);
                margin-bottom: 0px;
                border-radius: 8px 8px 0px 0px;
            }

            .config_item {
                border-radius: 0px 0px 8px 8px;

                .config_title {
                    margin-bottom: 10px;
                    font-size: 14px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: 20.27px;
                    color: rgba(36, 102, 168, 1);
                    text-align: left;
                    vertical-align: top;
                }

                .config_input_item {
                    display: flex;
                    align-items: center;
                    margin-bottom: 20px;
                }

                .item_text {
                    width: 200px;


                    .item_tag {
                        font-size: 14px;
                        font-weight: 400;
                        letter-spacing: 0px;
                        line-height: 20.27px;
                        color: rgba(166, 166, 166, 1);
                    }

                }
            }
        }
    }

    .form_time {
        margin-top: 30px;

        .time_title {
            margin-bottom: 20px;
        }

        .inputtime {
            margin-bottom: 30px;
        }

        span {
            display: inline-block;
            margin-right: 10px;
        }
    }

    .notice_box {
        margin-top: 30px;
        margin-bottom: 30px;
        border-bottom: 1px solid rgba(219, 219, 219, 1);

        .notice_title {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 21px;
            opacity: 1;
            font-size: 16px;
            font-weight: 500;
            letter-spacing: 0px;
            line-height: 20.27px;
            color: rgba(36, 102, 168, 1);
            margin-bottom: 20px;

            img {
                height: 16px;
                margin-left: 6px;
            }
        }

        .notice_type {
            margin-bottom: 26px;
        }

        .notice_man {
            margin-bottom: 26px;
        }

        .notice_conten {
            margin-bottom: 26px;

            .mytextarea {
                margin-top: 10px;
            }
        }
    }

    .state_box {
        margin-bottom: 30px;

        .statee_title {
            display: flex;
            align-items: center;
            // justify-content: center;
            height: 21px;
            opacity: 1;
            font-size: 16px;
            font-weight: 500;
            letter-spacing: 0px;
            line-height: 20.27px;
            color: rgba(36, 102, 168, 1);
            margin-bottom: 20px;

            img {
                height: 16px;
                margin-left: 6px;
            }
        }
    }
}

.upleft {
    margin-right: 10px;
}

.add_title {
    font-size: 20px;
    font-weight: 500;
    letter-spacing: 0px;
    line-height: 18.75px;
    color: rgba(36, 102, 168, 1);
    font-weight: 900;
    height: 40px;
    line-height: 40px;
    // margin-bottom: 20px;
    text-align: center;
}

::v-deep.el-collapse {
    border-top: 0px;
}

::v-deep.el-collapse-item__arrow {
    margin: 0 8px 0 10px;
    ;
}

::v-deep .el-input-number.is-controls-right .el-input-number__increase {
    background-color: transparent !important;
    border: 0px;
}

::v-deep.el-input-number.is-controls-right .el-input-number__decrease {
    background-color: transparent !important;
    border: 0px;
}

::v-deep.el-radio {
    // display: flex;
    // align-items: top;
}
</style>
